import z from 'zod'

import { iconSchema, pathSchema } from '../utility'

const linkSchema = z.object({
  type: z.literal('link'),
  title: z.string(),
  icon: iconSchema.optional(),
  style: z.enum(['text', 'button']).optional(),
  newTab: z.boolean().default(false).optional(),
  to: z.union([
    pathSchema.describe('A route path to another docs page, e.g. /about'),
    z.url().describe('An external link, e.g. https://www.example.com'),
  ]),
})

const headerSpacerSchema = z.object({
  type: z.literal('spacer'),
})

const headerItem = z.discriminatedUnion('type', [
  linkSchema,
  headerSpacerSchema,
])

export type HeaderItemSingle = z.infer<typeof headerItem>

const headerGroupSchema = z.object({
  type: z.literal('group'),
  title: z.string(),
  icon: iconSchema.optional(),
  children: headerItem.array(),
})

export const headerItemSchema = z.discriminatedUnion('type', [
  headerItem,
  headerGroupSchema,
])

export type HeaderItem = z.infer<typeof headerItemSchema>
